import { render } from "./PersonalCenter.vue?vue&type=template&id=b9928310&scoped=true"
import script from "./PersonalCenter.vue?vue&type=script&lang=js"
export * from "./PersonalCenter.vue?vue&type=script&lang=js"

import "./PersonalCenter.vue?vue&type=style&index=0&id=b9928310&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9928310"]])

export default __exports__